// TODO: Dead Feature

export default class HomepageFeaturedTrending {
  constructor(options){
    this.$element = $(options.element);
    this.uuid = this.generateId();
    this.name = this.$element.data('name');
  }

  init(){
    this.addUuidToDom();

    window.AhoyEvent.send("HOME::SECTION::GET",
      { uuid: this.uuid,
        platform: window.VidioHelpers.getPlatform(),
        section: this.name,
        app_name: "vidio",
        items: this.getItems(),
        section_position: -1,
        page_name: 'home'
      }
    );
  }

  getItems() {
     var video_items = this.$element.find("[data-video-id]");
     var items = [];
     video_items.each(function (index, object) {
       var itemProperties = {
         video_id: $(object).data("video-id"),
         position: $(object).data("position"),
         item_type: $(object).data("item-type")
       };
       var recommender = $(object).data("recommender");
       if (recommender) {
         itemProperties.recommender = recommender;
       }
       items.push(itemProperties);
     });
     return items;
  }

  // http://stackoverflow.com/a/8809472
  generateId() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }

  addUuidToDom(){
    this.$element.attr('data-uuid', this.uuid);
  }
}
